"use strict";
const merge = require("webpack-merge");
const prodEnv = require("./prod.env");

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  BASE_API: '"https://www.hnfsom.com/"',
  BASE: "https://www.hnfsom.com/file/",
  // BASE:'https://www.hanxin-chip.com/file/',
  // BASE:'http://192.168.5.3:88/',
  TYPE: 1, // 打包环境 1：国内，2：国外，3：国内外
});



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 1